import { useQuery, UseQueryResult } from 'react-query';
import { WatchList } from '../../models/WatchList';
import { fetchWatchLists } from '../../services/watchLists/watchLists.service';
import { queryKeys } from '../queryKeyFactory';
import { mapWatchListsDtoToWatchLists } from './utils/watchLists.mappers';

export default (): UseQueryResult<WatchList[], Error> =>
  useQuery<WatchList[], Error>([queryKeys.fetchWatchlists.all], async () => {
    const watchLists = await fetchWatchLists();

    return mapWatchListsDtoToWatchLists(watchLists);
  });
